var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{style:(_vm.inputStyle),attrs:{"src":_vm.logo.icon,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }